<template>
    <div>
        <!--业务咨询弹窗-->
        <Modal :closable="false"  footer-hide v-model="modalFade" title="投诉" class-name="customer-complaint" :width="600" @on-visible-change="modalChange" :mask-closable="false">
            <div slot="header" class="header">
                <div><img style="margin-top: 5px" height="40px" src="../images/yzslogo.png" alt=""></div>
                <div class="title">投诉与意见</div>
                <div style="text-align: right"><Icon @click="modalFade=false" class="closeIcon" type="android-close" size="22"></Icon></div>
            </div>
            <img src="../images/banner7.png" style="border-bottom-left-radius: 6px" width="164px" height="400px" alt="">
            <Form ref="complaintForm" style="width: 400px;margin-left: 10px" :label-width="80" :model="complaintForm">
                <div class="top"><h2>我们将尽快处理您的投诉意见！</h2><div>*为必填项</div></div>
                <div class="label required" style="display: inline-block">
                    您的邮箱：
                    <span class="tip" v-if="errorMessage.emailError!=''">({{errorMessage.emailError}})</span>
                </div>
                <FormItem prop="customerMail">
                    <Input @on-blur="validateCustomerMail" type="text" v-model="complaintForm.customerMail" placeholder="例：yazuishou@yazuishou.com"></Input>
                    <div style="text-align: right;color: #929292">(处理结果将发送至您邮件)</div>
                </FormItem>
                <div class="label required">
                    投诉内容：
                    <span class="tip" v-if="errorMessage.contentError!=''">({{errorMessage.contentError}})</span>
                </div>
                <FormItem prop="complainContent">
                    <Input @on-blur="validateComplainContent" type="textarea" :rows="6" :maxlength="500" v-model="complaintForm.complainContent" placeholder="请简要描述您的问题（500字内）"></Input>
                </FormItem>
                <div class="label" style="margin-left: 8px">图片上传：(最多4张)</div>
                <div class="upload-wrapper">
                    <div class="upload-item" v-for="(image, index) in uploadList" :key="index">
                        <!-- <embed v-if="complaintForm.uploadFile[index].type.indexOf('pdf') != -1" :src="image"></embed>
                        <img v-else :src="image"> -->
                        <img :src="image">
                        <div class="sign" style="cursor: pointer;">
                            <Icon type="ios-trash-outline" size='18' @click="deleteImage(index)"></Icon>
                        </div>
                    </div>
                    <div class="upload-item upload-box" v-if="uploadList.length != 4">
                        <Upload
                            multiple
                            :show-upload-list="false"
                            class="upload-file"
                            :before-upload="handleUpload"
                            action="">
                            <div style="width: 100%; height: 100%; overflow: hidden;">
                                <Icon type="ios-plus-empty" size='47' style="height: 50px; width: 50px;"></Icon>
                            </div>
                        </Upload>
                    </div>
                </div>
                <div style="height: 24px; line-height: 24px; color: #ed3f14;">
                    <span v-text="uploadError"></span>
                </div>
                <Button style="float: right" type="warning" :loading="loading" @click="valiSubmit">提交</Button>
                
            </Form>
            
        </Modal>
        <Modal v-model="successModal.fade" style="text-align: center;" :mask-closable="false" width='300' @on-visible-change="modalChange(false)">
            <p style="margin-bottom: 10px;">
                <Icon type="checkmark-circled" size="60" color="#19be6b"></Icon>
            </p>
            <h1>提交成功</h1>
            <p style="font-size: 16px;">我们已经收到并且十分重视您的建议</p>
            <p style="font-size: 16px;">请耐心等待，1个工作日内会联系您</p>
            <div slot="footer">
                <Button type="primary" size="large" long @click="successModal.fade = false; modalChange(false)">关闭</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
    import Cookies from 'js-cookie';
    import axios from 'axios';
    import util from '../libs/util';
    export default {
        props: {
            fade: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                modalFade: false,
                complaintForm: {},
                uploadList: [],
                successModal: {
                    fade: false
                },
                loading: false,
                uploadError: '',
                errorMessage: {
                }
            };
        },
        mounted() {
            // this.getDoorAreas()
        },
        computed: {
        },
        watch: {
            fade(val) {
                if(val) this.initData()
                this.modalFade = util.deepClone(val)
            },
        },
        methods: {
            initData() {
                this.complaintForm = {
                    complainContent: '',
                    customerMail: '',
                    uploadFile: []
                }
                this.errorMessage = {
                    emailError: '',
                    contentError: ''
                }
                this.uploadError = ''
                this.uploadList = []
            },
            modalChange(val) {
                // this.fade = val;
                if(!val) this.$emit('change', val)
            },
            handleUpload(file) {
                // if(this.file.attachment.length >= 10) {
                //     this.$Message.error('上传的附件最多为10个!'); 
                //     return
                // }
                this.uploadError = ''
                if(this.complaintForm.uploadFile.length >= 4) return false
                if(!/jpg|jpeg|png|gif|rtf/.test(file.type)) {
                    this.uploadError = '请上传图片格式文件'
                    return false
                }
                this.complaintForm.uploadFile.push(file)
                let reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onloadend = () => {
                    this.uploadList.push(reader.result)
                };
                return false;
            },
            deleteImage(index) {
                this.uploadList.splice(index, 1)
                this.complaintForm.uploadFile.splice(index, 1)
            },
            valiSubmit() {
                    this.validateComplainContent();
                    this.validateCustomerMail();
                    if (!this.errorMessage.emailError && !this.errorMessage.contentError) {
                        if(this.complaintForm.uploadFile.length != 0) {
                            if(this.complaintForm.uploadFile.some(image => !/jpg|jpeg|png|gif|rtf/.test(image.type))) {
                                this.uploadError = '请上传图片格式文件'
                                return
                            }
                            if(this.complaintForm.uploadFile.some(image => image.size/(1024*1024) > 10)) {
                                this.uploadError = '上传的图片单张大小不能大于10MB'
                                return
                            }
                        }
                        this.submit()
                    } else {
                        this.$Message.error('请填写完整信息!');
                    }
            },
            validateComplainContent() {
                if (this.complaintForm.complainContent === '') {
                    this.errorMessage.contentError = '内容不能为空';
                } else {
                    this.errorMessage.contentError = ''
                }
            },
            validateCustomerMail() {
                if(this.complaintForm.customerMail === '') {
                    this.errorMessage.emailError = '结果不能为空'
                } else if(!/^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/.test(this.complaintForm.customerMail)) {
                    this.errorMessage.emailError = '请输入有效邮箱'
                } else {
                    this.errorMessage.emailError = ''
                }
            },
            submit() {
                let formData = new FormData()
                for(let key in this.complaintForm) {
                    if(key == 'uploadFile') {
                        if(this.complaintForm.uploadFile.length != 0) {
                            this.complaintForm.uploadFile.forEach(file => {
                                formData.append(key, file)
                            })
                        }
                    } else {
                        formData.append(key, this.complaintForm[key])
                    }
                }

                this.loading = true
                util.ajax_submitFile(this, '/ws-truck/duckBill/complaint/uploadCustomerComplaint', formData , response => {
                    this.loading = false
                    if(response.data.success) {
                        this.successModal.fade = true
                    } 
                });
            }
        }
    };
</script>

<style lang="less">
.customer-complaint{
    .ivu-modal{
        .ivu-modal-content{
            .ivu-modal-header{
                padding: 0;
                .closeIcon{
                margin-top: 13px;
                margin-right: 15px;
                cursor:pointer;
                color: white;
                &:hover{
                    color: grey;
                }
            }
            }
            .ivu-modal-body{
                padding: 0;
                display: flex;
                img{
                    width: 164px;
                }
            }
        }
    }
}

</style>
<style lang='less' scoped>
//绝对居中
.inner() {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}

.customer-complaint {
    .header {
        display: flex;
        background: #3b425e;
        height: 50px;
        line-height: 50px;
        vertical-align: middle;
        border-radius: 5px;
        div{
            flex: 1;
            
        }
        .title{
            text-align: center;
            color: white;
            font-size: 18px;
        }
    }
    .ivu-form-item{
        margin-bottom: 10px;
    }
    .top{
        width: 430px;
        margin-bottom: 10px;
        h2 {
            display: inline-block;
            margin-top: 8px;
            margin-left: 8px;
        }
        div{
            float: right;
            color: #ed3f14;
            font-size: 14px;
            margin-right: 10px;
        }
    }
    .upload-wrapper {
        display: flex;
        width: 260px;
        margin-left: 80px;
        float: left;
        // justify-content: space-around;
        .upload-item {
            width: 50px;
            height: 50px;
            margin-right: 5px;
            position: relative;
            border: 1px dashed #ccc;
            overflow: hidden;
            .upload-file {
                width: 100%;
                height: 100%;
                text-align: center;
                position: relative;
                cursor: pointer;
                i {
                    margin: 0 auto;
                }
            }
            img {
                max-width: 100%;
                max-height: 100%;
                .inner;
            }
            .sign {
                position: absolute;
                line-height: 20px;
                width: auto;
                padding: 0 6px;
                top: 0;
                right: 0;
                color: #fff;
                background-color: rgba(0, 0, 0, .5)
            }
            embed {
                position: absolute;
                left: 0; 
                top: -57px;
                width: ~'calc(100% + 17px)';
                height: ~'calc(100% + 74px)';
            }
        }
    }
    .label {
        line-height: 20px;
        color: #888;
        font-size: 14px;
        .tip {
            font-size: 12px;
            color: #ed3f14;
        }
        &.required {
            &::before {
                content: "*";
                display: inline-block;
                line-height: 1;
                font-family: SimSun;
                font-size: 12px;
                color: #ed3f14;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// customer-complaint.vue?c4b86796